import styled from 'styled-components';
import { TypeColorNames } from '../../../theme/colors';

const IconContainer = styled.span<{color?: TypeColorNames}>`
    display: flex;
    align-items: center;

    svg {
        fill: ${(props) => props.color ? props.theme.colors[props.color] : props.theme.colors.border};
    }

    svg:hover {
        fill: ${(props) => props.color ? props.theme.colors[props.color] : props.theme.colors.title};
    }
`;

const SixDotsIcon = ({color}: {color?: TypeColorNames}) => {
    return (
        <IconContainer color={color}>
            <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 14.2305C4 15.3305 3.1 16.2305 2 16.2305C0.9 16.2305 0 15.3305 0 14.2305C0 13.1305 0.9 12.2305 2 12.2305C3.1 12.2305 4 13.1305 4 14.2305ZM2 6.23047C0.9 6.23047 0 7.13047 0 8.23047C0 9.33047 0.9 10.2305 2 10.2305C3.1 10.2305 4 9.33047 4 8.23047C4 7.13047 3.1 6.23047 2 6.23047ZM2 0.230469C0.9 0.230469 0 1.13047 0 2.23047C0 3.33047 0.9 4.23047 2 4.23047C3.1 4.23047 4 3.33047 4 2.23047C4 1.13047 3.1 0.230469 2 0.230469ZM8 4.23047C9.1 4.23047 10 3.33047 10 2.23047C10 1.13047 9.1 0.230469 8 0.230469C6.9 0.230469 6 1.13047 6 2.23047C6 3.33047 6.9 4.23047 8 4.23047ZM8 6.23047C6.9 6.23047 6 7.13047 6 8.23047C6 9.33047 6.9 10.2305 8 10.2305C9.1 10.2305 10 9.33047 10 8.23047C10 7.13047 9.1 6.23047 8 6.23047ZM8 12.2305C6.9 12.2305 6 13.1305 6 14.2305C6 15.3305 6.9 16.2305 8 16.2305C9.1 16.2305 10 15.3305 10 14.2305C10 13.1305 9.1 12.2305 8 12.2305Z" />
            </svg>
        </IconContainer>
    )
}

export default SixDotsIcon;